import { type Maybe, sortBy } from '@vrplatform/utils';
import type { StatementTemplate } from '../_types';

export const getStatementTemplate = <
  T extends { template: Maybe<StatementTemplate> },
>(
  statements: T[]
) =>
  sortBy(
    (statements || []).map((st) => st.template),
    (x) => x?.version || 0
  ).reverse()[0];
